import HttpRequest from "@/api/axios";
import moment    from 'moment'
const axios = new HttpRequest(process.env.VUE_APP_API_BASE_URL);

export default {
    activityDetail(data) {
        return axios.request({
            url: "activity/detail",
            method: "post",
            data
        });
    },
    winList(data) {
        return axios.request({
            url: "activity/winlist",
            method: "post",
            data
        });
    },
    drawonce(data) {
        return axios.request({
            url: "activity/drawonce",
            method: "post",
            data
        });
    },
    taskList(data){
        return axios.request({
            url: "activity-sub/sub_list",
            method: "get",
            params:data
        }).then((res)=>{
            if(res.status*1===200){
                let {start_time,end_time} = res.data
                res.data.start_time_show = moment(start_time*1000).format("YYYY-MM-DD HH:mm:ss");
                res.data.end_time_show = moment(end_time*1000).format("MM-DD HH:mm:ss");
            }
            return res;

        });
    },
    taskDetail(data){
        return axios.request({
            url: `activity-sub/${data.id}`,
            method: "get",
            params:data
        })
    },
    taskCheckin(data){
        return axios.request({
            url: `activity-sub/checkin`,
            method: "post",
            data,
            params:{token:data.token}
        });
    },
    getCert(data){
        return axios.request({
            url: `activity/cert`,
            method: "get",
            params:data
        });
    },
    hpGrank(data) {
        return axios.request({
            url: "huangpu/singlerank",
            method: "post",
            data
        });
    },
    groupRank(data) {
        return axios.request({
            url: "activity/group-rank",
            method: "get",
            params:data
        });
    },
    hpSup(data) {
        return axios.request({
            url: "huangpu/singleupload",
            method: "post",
            data
        });
    },
    hpGrmatch(data) {
        return axios.request({
            url: "huangpu/groupindex",
            method: "post",
            data
        });
    },
    hpaddress(data) {
        return axios.request({
            url: "huangpu/address",
            method: "post",
            data
        });
    },
    hpGroupUp(data) {
        return axios.request({
            url: "huangpu/groupupload",
            method: "post",
            data
        });
    },
    hpGetques(data) {
        return axios.request({
            url: "huangpu/groupquestion",
            method: "post",
            data
        });
    },
    hpSubQues(data) {
        return axios.request({
            url: "huangpu/groupsubmitquestion",
            method: "post",
            data
        });
    },
    grouprank(data) {
        return axios.request({
            url: "huangpu/grouprank",
            method: "post",
            data
        });
    },
    qrcoderank(data) {
        return axios.request({
            url: "activity/qrcode-rank",
            method: "post",
            data
        });
    },
		
}
